const state = {
  loading: false,
  openNav: true,
  object: {},
  menu: undefined,
  isSideWindowOpen: false,
  isSideWindowLoading: false,
  isDataSide: undefined,
  isComponentSide: undefined,
  loadingSide: false,
  playbook: undefined,
  resultCalculatorCVSS: undefined
}

const mutations = {
  isPlaybook(state, item) {
    state.playbook = {
      ...state.playbook,
      ...item,
    }
  },
  resultCalculatorCVSS(state, payload) {
    state.resultCalculatorCVSS = payload
  },
  isLoadingSide(state, loading) {
    state.loadingSide = loading
  },
  isMenu(state, menu) {
    state.menu = menu
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  setOpenNav(state, bool) {
    state.openNav = bool
  },
  setObjectChat(state, object) {
    state.object = object
  },
  isSideWindowOpen(state, forceStatus) {
    if (forceStatus !== undefined) {
      state.isSideWindowOpen =  forceStatus
    } else {
      state.isSideWindowOpen =  !state.isSideWindowOpen
    }
  },
  sideWindowLoading(state, data) {
    state.isSideWindowLoading = data
  },
  isDataSide(state, data) {
    state.isDataSide = data
  },
  isComponentSide(state, component) {
    state.isComponentSide = component
  },
}

const getters = {
  isPlaybook: state => state.playbook,
  isSideWindowOpen: state => state.isSideWindowOpen,
  isSideWindowLoading: state => state.isSideWindowLoading,
  isComponentSide: state => state.isComponentSide,
  isDataSide: state => state.isDataSide,
  loadingSide: state => state.loadingSide,
  resultCalculatorCVSS: state => state.resultCalculatorCVSS,
  isLoading: state => {
    return state.loading
  },
  isNav: state => {
    return state.openNav
  },
  isObject: state => {
    return state.object
  },
  isMenu: state => state.menu,
}

export default {
  state,
  mutations,
  getters,
}
